import { latestMonthOf } from "@/components/analysisModules/TopicClusteringTreeViewV2/PrioritiesLayoutV2";
import { CONFIG } from "@/components/analysisModules/TopicClusteringTreeView/PrioritiesLayout/CONFIG";

/**
 * What the Priorities widget stores (props.tempWidgetProps) and the options
 * its config panel offers. The Component and the ConfigForm both read from
 * here so a default lives in one place.
 */

// The period picker's first option: whichever calendar month is latest at
// render time, so a saved widget keeps moving forward as months land —
// the Priorities page's own landing.
const LATEST_MONTH = "latest_month";

const HIDDEN_COLUMNS_NONE = [];

export const DEFAULTS = {
  // "findings" (sub-topics), "buckets" (topics), or "both" — the viewer gets
  // the Sub-topics / Topics switch, landing on sub-topics.
  scoreGrain: "findings",
  // "field" (the bubble chart) or "table".
  layout: "field",
  // In table layout: "priorities", "wins", or "both" — the viewer gets the
  // Priorities / Wins switch, landing on priorities.
  tableTab: "both",
  // Table columns the author has hidden, by colId. HIDDEN rather than shown
  // so a column added to the table later shows up on widgets saved before
  // it existed. A stable array — it is a memo dependency downstream.
  hiddenColumns: HIDDEN_COLUMNS_NONE,
  periodValue: LATEST_MONTH,
  // How many periods the trend spans — the page's 2 / 3 / 6 pills.
  // What the widget opens on; the viewer can still move it when the pills
  // are shown.
  trendWindow: CONFIG.TREND_WINDOW,
  showTrendWindow: true,
  showZoneBar: true,
  showActFirst: false,
};

export const GRAIN_OPTIONS = [
  { value: "findings", display: "Sub-topics" },
  { value: "buckets", display: "Topics" },
  { value: "both", display: "Both — viewer switches" },
];

export const LAYOUT_OPTIONS = [
  { value: "field", display: "Bubble chart" },
  { value: "table", display: "Table" },
];

export const TABLE_TAB_OPTIONS = [
  { value: "priorities", display: "Priorities" },
  { value: "wins", display: "Wins" },
  { value: "both", display: "Both — viewer switches" },
];

export const TREND_WINDOW_OPTIONS = CONFIG.TREND_WINDOW_OPTIONS.map((n) => ({
  value: n,
  display: `${n} periods`,
}));

/** The period picker: "latest month" first, then every period the tenant offers. */
export const periodPickerOptions = (periods = []) => [
  { value: LATEST_MONTH, display: "Latest month" },
  ...periods,
];

/**
 * The period the widget scores around. A stored period that has since
 * left the options (a week rolled off, say) falls back the same way the
 * default does, so the widget never renders on a period the API does not know.
 */
export const resolvePeriod = (periods = [], periodValue = LATEST_MONTH) =>
  (periodValue !== LATEST_MONTH && periods.find((o) => o.value === periodValue)) ||
  latestMonthOf(periods) ||
  periods[0] ||
  null;

/** The picker's card for a stored value — the option, with its section as the small label above. */
export const pickerValue = (options, value, dataType) => {
  const option = options.find((o) => o.value === value);
  return option ? { ...option, dataType } : null;
};
